import { ReactNode, useLayoutEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import type { HomeId } from '@racepointenergy/swc/scs/types'
import { notAvailableHostMessages } from 'features/home/components/HomeStatus/MainInfo/messages'
import { SpinnerCentered } from 'components/Loader'

import SysMonUnavailable from './SysMonUnavailable'
import AvailabilityChecker from './AvailabilityChecker'
import { homeConfigActions } from '../components/HomeConfiguration/slice'

export interface GuardRouterProps
  extends RouteComponentProps<{ homeId: HomeId }> {}

interface SysMonGuardProps {
  homeId: HomeId
  title: ReactNode
  children: ReactNode
}

const SysMonGuard = ({ homeId, title, children }: SysMonGuardProps) => {
  const dispatch = useDispatch()

  useLayoutEffect(() => {
    dispatch(homeConfigActions.clear())
  }, [dispatch])

  return (
    <AvailabilityChecker homeId={homeId}>
      {({ errors, isAvailabilityLoading }) => {
        if (isAvailabilityLoading) return <SpinnerCentered />

        if (errors?.length) {
          return (
            <SysMonUnavailable
              pageTitle={title}
              title={
                <FormattedMessage
                  {...notAvailableHostMessages.sysMonUnavailableTitle}
                />
              }
              captions={errors}
            />
          )
        }

        return children
      }}
    </AvailabilityChecker>
  )
}

export default SysMonGuard
